import { useAtom } from 'jotai';
import { walletIdAtom } from '../web3Store.atoms';
import { EWalletId, EWalletType } from '../web3Store.enums';

export default function useWalletId(type: EWalletType): [EWalletId | undefined] {
	const [walletId] = useAtom(walletIdAtom(type));

	return [walletId];
}
